import { Box } from '@components/Box';
import { CTALink } from '@components/CTALink';
import { TextPairing } from '@components/TextPairing';
import { themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';

export const StyledContainer = styled(Box)`
  border-radius: ${themeSpace(5)};
  background-color: white;
  padding: ${themeSpace(5)} ${themeSpace(5)} ${themeSpace(10)};
`;

export const StyledTextPairing = styled(TextPairing)`
  align-items: center;
  .text-pairing-title {
    font-weight: 700;
  }
`;

export const StyledCTALink = styled(CTALink)`
  color: ${props => props.theme.colors.mono1};
`;
